"use client"
import {
  Lockup as DSLockup,
  LockupAction as DSLockupAction,
  type LockupActionProps as DSLockupActionProps,
  LockupAvatar as DSLockupAvatar,
  type LockupAvatarProps as DSLockupAvatarProps,
  LockupContent as DSLockupContent,
  type LockupContentProps as DSLockupContentProps,
  LockupDescription as DSLockupDescription,
  type LockupDescriptionProps as DSLockupDescriptionProps,
  type LockupProps as DSLockupProps,
  LockupSide as DSLockupSide,
  type LockupSideProps as DSLockupSideProps,
  LockupTitle as DSLockupTitle,
  type LockupTitleProps as DSLockupTitleProps,
} from "@opensea/ui-kit"
import { AvatarImage, type AvatarProps } from "../Avatar"

export type LockupProps = DSLockupProps
export type LockupContentProps = DSLockupContentProps
export type LockupTitleProps = DSLockupTitleProps
export type LockupDescriptionProps = DSLockupDescriptionProps
export type LockupSideProps = DSLockupSideProps
export type LockupActionProps = DSLockupActionProps
export type LockupAvatarProps = DSLockupAvatarProps

export function Lockup(props: LockupProps) {
  return <DSLockup {...props} />
}

export function LockupAvatar(props: AvatarProps) {
  return <DSLockupAvatar renderImage={AvatarImage} {...props} />
}

export const LockupContent = DSLockupContent
export const LockupTitle = DSLockupTitle
export const LockupDescription = DSLockupDescription
export const LockupSide = DSLockupSide
export const LockupAction = DSLockupAction
